<template lang="pug">
    v-layout(justify-center)
      v-progress-circular.progress-circular(
          v-if="isLoading"
          indeterminate
          color="primary"
        )
      v-snackbar(:value="fileErrorMessage" color="error")
        div {{ fileErrorMessage }}
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const {
  mapActions: mapExportedFilesActions,
  mapState: mapExportedFilesState,
} = createNamespacedHelpers('exportedFiles');

export default {
  methods: {
    
  },
  computed: {
    ...mapExportedFilesState([
      'fileData',
      'fileErrorMessage',
      'isLoading',
    ]),
  },
  created() {
      this.getFile({
        fileId: this.$route.params.id
      });
  },
  watch: {
    fileData(value) {
      this.handleFileData(value);
    },
  },
  methods: {
    ...mapExportedFilesActions([
      'getFile',
    ]),
    handleFileData(fileData) {
      if (!fileData || !fileData.data) return;

      const fileURL = window.URL.createObjectURL(fileData.data);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', fileData.fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-circular {
  margin-top: 40vh;
}
</style>
